// extracted by mini-css-extract-plugin
export default {"addRelation":"AddNewFamilyMemberButton_addRelation__nEkqX"};